import React, { useState } from 'react';
import { PrimeReactCalendar, PrimeReactDropdown, PrimeReactMultiSelect } from 'components/common';
import { Tooltip } from 'primereact/tooltip';
import CaseListDropDown from 'components/CaseListDropDown/CaseListDropDown';

function FilterFacets(props) {
  const { filterValues, onChangeFilterFacets, automationErrorLogCodeOptions, automationErrorLogStatusOptions, onResetFilterFacets } =
    props || {};

  const [selectedCase, setSelectedCase] = useState(null);

  return (
    <>
      <div className="d-inline-flex filter-wrap autowidth">
        <div className="">
          <span className="p-input-icon-left input-shadow"></span>
        </div>
        <div className="d-flex align-items-center autowidth">
          <div className="d-flex align-items-center filter-wraper w-100">
            <div className="d-flex flex-wrap align-items-center p-2">
              <span className="text-bold black-600 me-2 filter-label my-1">Filters: </span>
              <div className="d-flex flex-column ms-2 filter-wraper my-1 ">
                {/* <PrimeReactMultiSelect
                  value={filterValues?.case || ''}
                  options={casesList}
                  onChange={(e) => {
                    onChangeFilterFacets(e);
                  }}
                  placeholder="By Case"
                  name="case"
                  display="chip"
                  className="me-2 input-shadow w-100 F-size14 searchable-dropdown"
                  filter
                  filterPlaceholder="Search"
                  resetFilterOnHide //clearing search keyword on hide
                /> */}

                <CaseListDropDown
                  value={selectedCase || null}
                  onChange={(selectedOption) => {
                    setSelectedCase(selectedOption);
                    if (selectedOption?.id) {
                      onChangeFilterFacets({
                        target: { name: 'case_lead', value: [selectedOption?.id] },
                      });
                    } else {
                      onChangeFilterFacets({
                        target: { name: 'case_lead', value: [] },
                      });
                    }
                  }}
                  name="case_lead"
                  isClearable
                  placeholder="By Case/Lead"
                  noOptionsMessage="No Cases/Leads Found"
                  isClient={false}
                  disabled={false}
                  excludeFromLoading={true}
                />
              </div>
              {/* <div className="d-flex flex-column ms-2 filter-wraper my-1 "> */}
              {/* <PrimeReactMultiSelect
                  value={filterValues?.lead || ''}
                  options={leadsList}
                  onChange={(e) => {
                    onChangeFilterFacets(e);
                  }}
                  name="lead"
                  placeholder="By Lead"
                  className="me-2 input-shadow w-100 F-size14 searchable-dropdown"
                  display="chip"
                  filter
                  filterPlaceholder="Search"
                  resetFilterOnHide //clearing search keyword on hide
                /> */}
              {/* <CaseListDropDown
                  value={selectedLead || null}
                  onChange={(selectedOption) => {
                    setSelectedLead(selectedOption);
                    if (selectedOption?.id) {
                      onChangeFilterFacets({
                        target: { name: 'lead', value: [selectedOption?.id] },
                      });
                    } else {
                      onChangeFilterFacets({
                        target: { name: 'lead', value: [] },
                      });
                    }
                  }}
                  name="lead"
                  isClearable
                  placeholder="By Lead"
                  noOptionsMessage="No Leads Found"
                  isClient={false}
                  disabled={false}
                />
              </div> */}
              <div className="d-flex flex-column ms-2 filter-wraper my-1 ">
                <PrimeReactMultiSelect
                  value={filterValues?.errorCode || ''}
                  options={automationErrorLogCodeOptions}
                  onChange={(e) => {
                    onChangeFilterFacets(e);
                  }}
                  name="errorCode"
                  placeholder="By Error Type"
                  className="me-2 input-shadow w-100 F-size14 searchable-dropdown"
                  display="chip"
                  filter
                  filterPlaceholder="Search"
                  resetFilterOnHide //clearing search keyword on hide
                />
              </div>

              <div className="d-flex flex-column ms-2 filter-wraper my-1 ">
                <PrimeReactDropdown
                  value={filterValues?.status || ''}
                  options={automationErrorLogStatusOptions}
                  onChange={(e) => {
                    onChangeFilterFacets(e);
                  }}
                  name="status"
                  className=""
                  placeholder="By Status"
                />
              </div>
              <div className="d-flex flex-column ms-2 filter-wraper my-1 ">
                <PrimeReactCalendar
                  selectionMode="range"
                  name="createdDate"
                  value={filterValues?.createdDate || [new Date()]}
                  onChange={(e) => {
                    onChangeFilterFacets(e);
                  }}
                  showIcon={true}
                  id="icon"
                  className="input-shadow filter-calender"
                  placeholder="By Date"
                />
              </div>
              <div className="pointer refresh-icon ms-0 p-2 my-1">
                <i
                  className="fas fa-sync-alt"
                  onClick={() => {
                    onResetFilterFacets();
                    setSelectedCase(null);
                  }}
                ></i>
                <Tooltip content="Reset Filter" position="top" target=".fa-sync-alt" showDelay={500} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FilterFacets;
